<template>
  <div :class="t.wrapper">
    <label :class="t.label">
      {{ question.prompt }}
      <span v-if="!question.required" class="text-gray-400 font-normal">(optional)</span>
    </label>
    <p
      v-if="question.subtext"
      :class="t.subtext"
      v-html="question.subtext"
    ></p>
    <input
      v-model="answer"
      type="text"
      :class="[t.input, error ? 'border-red-500' : 'border-gray-300']"
      :style="inputFocusStyle"
      @focus="handleFocus"
      @blur="handleBlur"
      placeholder="Enter your answer"
    />
    <p v-if="error" :class="t.error">
      Please enter an answer.
    </p>
  </div>
</template>

<script>
import { tokensFor } from './size_tokens';

export default {
  name: 'QuestionShortText',
  props: {
    question: {
      type: Object,
      required: true,
    },
    existingAnswer: {
      type: Object,
      default: null,
    },
    size: {
      type: String,
      default: 'kiosk',
      validator: (v) => ['kiosk', 'form'].includes(v),
    },
  },
  data() {
    return {
      answer: '',
      originalAnswer: '',
      error: false,
      isFocused: false,
    };
  },
  computed: {
    t() {
      return tokensFor(this.size);
    },
    inputFocusStyle() {
      if (this.isFocused) {
        return {
          borderColor: 'var(--team-primary)',
          boxShadow: '0 0 0 3px rgba(var(--team-primary-rgb, 55, 65, 81), 0.1)',
        };
      }
      return {};
    },
    dirty() {
      return this.answer !== this.originalAnswer;
    },
    valid() {
      if (this.question.required) {
        return this.answer.trim().length > 0;
      }
      return true;
    },
  },
  watch: {
    answer() {
      this.emit();
      if (this.valid) {
        this.error = false;
      }
    },
  },
  created() {
    if (this.existingAnswer && this.existingAnswer.answer) {
      this.answer = this.existingAnswer.answer;
      this.originalAnswer = this.existingAnswer.answer;
    }
    this.$notificationManager?.on('show-reg-errors', this.validate);
  },
  destroyed() {
    this.$notificationManager?.off('show-reg-errors', this.validate);
  },
  methods: {
    emit() {
      this.$emit('answer-changed', this.question, this.answer, this.dirty, this.valid);
    },
    validate() {
      this.error = !this.valid;
    },
    handleFocus() {
      this.isFocused = true;
    },
    handleBlur() {
      this.isFocused = false;
      this.validate();
    },
  },
};
</script>
